// Library Methods
import { useContext } from "react";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SummarySection from "./SummarySection/SummarySection";

// Contexts
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

const FusionAndVergenceGraph = () => {
  const { t } = useTranslation();
  const { examReport } = useContext(ReportSectionContext);

  const summary = examReport?.postProcessing?.summary;
  const fusionalAmplitudes = summary?.FusionalAmplitudes;
  const vergenceFunction = summary?.VergenceFunction;

  if (!fusionalAmplitudes && !vergenceFunction) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography fontSize="14px" fontWeight={600} color="#E10C0C">
          {t("No Data Available.")}
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" width="100%" gap="24px">
      <SummarySection summary={examReport?.postProcessing?.summary} />
    </Box>
  );
};

export default FusionAndVergenceGraph;
